import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { SearchInput } from "../../components/Common/SearchInput";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { GiftReportFilter } from "../../components/Reports/GiftReport/GiftReportFilter";
import { GiftReportSummary } from "../../components/Reports/GiftReport/GiftReportSummary";
import { GiftReportTable } from "../../components/Reports/GiftReport/GiftReportTable";
import { Page } from "../Page";
import { ProductOption } from "../Product/SelectExperiencePage";

export const GiftReportPage = () => {
    const history = useHistory();
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebounce(search, 500);

    const handleClick = () => {
        history.push("/reports/gifts");
    };

    const handleChange = (searchResult: string) => {
        setSearch(searchResult);
    };

    const handleGiftButtonClick = () => {
        history.push(`/cart/init?filter=${ProductOption.GIFT_OFFERS}`);
    };

    return (
        <Page title="Gifts / Store Credits">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Gifts & Store Credits</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <SearchInput
                        className="relative w-full flex-1"
                        placeholder="Name, email or gift code"
                        onChange={handleChange}
                    />
                    <Button color="success" onClick={handleGiftButtonClick}>
                        Buy Gift
                    </Button>
                </HeaderToolbar>

                <GiftReportFilter />
                <GiftReportSummary />
                <GiftReportTable search={debouncedSearch} />
            </ColumnLayout>
        </Page>
    );
};
